module.exports = __webpack_public_path__ + "static/media/gofore.5bfd3e80.svg";